import { useState, useEffect } from "react";
import useApi from "./useApi";

interface SubscriptionPlan {
  planName: string;
  /** The configured term's label ("3 months"), when the price is one this deployment sells. */
  planLabel?: string | null;
  price: number;
  currency: string;
  interval: string;
  intervalCount: number;
  /** False for a one-off term, which must not be rendered as a recurring period. */
  recurring?: boolean;
  features: string[];
}

export default function useSubscriptionPlan() {
  const api = useApi();
  const [planDetails, setPlanDetails] = useState<SubscriptionPlan | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchPlanDetails = async () => {
      try {
        setIsLoading(true);
        setError(null);
        // The CALLER'S subscription, not the deployment's advertised plan. /subscription/plan
        // answers "what does membership cost" in the singular — with realtime pricing off it is a
        // hardcoded 99.99 placeholder, and with it on it is the first configured plan. Neither is
        // what this patient bought, which is what a billing screen has to show. /my-plan falls
        // back to that same advertised plan when the caller has no subscription of their own.
        const response = await api.get("/subscription/my-plan");
        setPlanDetails(response.data);
      } catch (error) {
        console.error("Error fetching plan details:", error);
        setError("Failed to load plan details");
        setPlanDetails(null);
      } finally {
        setIsLoading(false);
      }
    };

    fetchPlanDetails();
  }, [api]);

  return { planDetails, isLoading, error };
}
